// export const backendUrl = "process.env.REACT_APP_BACKEND_URL";
export const backendUrl = "https://apiekurpik.bieda.it/api";
// export const backendUrl = "http://localhost:8080/api"; //TODO